import { EstimateSection } from '@/components/site/EstimateForm';
import { Seo } from '@/components/site/Seo';

export default function Estimate() {
  return (
    <div data-testid="page-estimate">
      <Seo
        title="Request an Estimate | HearthOak Construction, LLC"
        description="Request a written estimate for home repairs, painting, drywall, doors, or carpentry in Fort Worth, Burleson & DFW. The owner reviews every request."
        path="/estimate"
      />
      <EstimateSection testIdPrefix="estimate" headingTag="h1" />
    </div>
  );
}
